import i18n from '@/i18n';

export const options: any = {
  tt: {
    img: 'https://website-resource.ahaglobal.io/ads-platform/authorization-code-tt.png',
    notes: [
      i18n.t('modal.authorization_code.tt_step1', {
        defaultValue:
          '<b>Tap the "Share" button (three dots)</b> on the video you want to authorize.'
      }),
      i18n.t('modal.authorization_code.tt_step2', {
        defaultValue:
          '<b>Go to Ad settings</b> and turn on <b>"Ad authorization".</b>'
      }),
      i18n.t('modal.authorization_code.tt_step3', {
        defaultValue:
          '<b>Tap "Generate code"</b>, select 365 days, then copy and share the code with us(the advertiser).'
      })
    ]
  },
  ins: {
    img: 'https://website-resource.ahaglobal.io/ads-platform/authorization-code-ins.png',
    notes: [
      i18n.t('modal.authorization_code.ins_step1', {
        defaultValue: '<b>Tap the three dots</b> and select <b>"Edit".</b>'
      }),
      i18n.t('modal.authorization_code.ins_step2', {
        defaultValue: 'Click <b>"Add paid partnership label",</b> '
      }),
      i18n.t('modal.authorization_code.ins_step3', {
        defaultValue:
          '<b>Then tap "Generate branded content ad code"</b> and share the 17-digit code.'
      })
    ]
  }
};

export const mobileOptions: any = {
  tt: {
    img: 'https://website-resource.ahaglobal.io/ads-platform/authorization-code-tt-mobile.png',
    notes: [
      i18n.t('modal.authorization_code.tt_step1', {
        defaultValue:
          '<b>Tap the "Share" button (three dots)</b> on the video you want to authorize.'
      }),
      i18n.t('modal.authorization_code.tt_step2', {
        defaultValue:
          '<b>Go to Ad settings</b> and turn on <b>"Ad authorization".</b>'
      }),
      i18n.t('modal.authorization_code.tt_step3', {
        defaultValue:
          '<b>Tap "Generate code"</b>, select 365 days, then copy and share the code with us(the advertiser).'
      })
    ]
  },
  ins: {
    img: 'https://website-resource.ahaglobal.io/ads-platform/authorization-code-ins-mobile.png',
    notes: [
      i18n.t('modal.authorization_code.ins_step1', {
        defaultValue: '<b>Tap the three dots</b> and select <b>"Edit".</b>'
      }),
      i18n.t('modal.authorization_code.ins_step2', {
        defaultValue: 'Click <b>"Add paid partnership label",</b> '
      }),
      i18n.t('modal.authorization_code.ins_step3', {
        defaultValue:
          '<b>Then tap "Generate branded content ad code"</b> and share the 17-digit code.'
      })
    ]
  }
};
